<template>
  <div v-if="loading" class="loading-bar">
    <atom-spinner :animation-duration="1000" :size="60" color="#ff1d5e" class="mx-auto" />
  </div>
  <div v-else>
    <vx-card>
      <vs-table
        :max-items="descriptionItems[0]"
        pagination
        :data="filteredPlanList"
        description
        search
        :description-items="descriptionItems"
        description-title="Registries"
        description-connector="of"
        description-body="Pages"
      >
        <template slot="header">
          <div class="list-heading">
            {{ $t("setup.label.PlanPricing") }}
          </div>
          <div class="mr-2 mb-1 order-1">
            <v-select
              label="label"
              :reduce="(option) => option.value"
              v-model="selectType"
              :options="typeOptions"
              :placeholder="$t('setup.label.SelectType')"
              class="min-w-200 w-full"
            >
            </v-select>
          </div>
          <div class="mr-2 mb-1 order-1">
            <vs-button
              icon-pack="feather"
              icon="icon-plus"
              @click="$router.push({ name: 'Create Plan' })"
              size="small"
              >{{ $t("setup.label.CreatePlan") }}</vs-button
            >
          </div>
        </template>
        <template slot="thead">
          <vs-th>{{ $t("setup.label.PlanCode") }}</vs-th>
          <vs-th>{{ $t("setup.label.Status") }}</vs-th>
          <vs-th>{{ $t("setup.label.Version") }}</vs-th>
          <vs-th>{{ $t("setup.label.IsOverride") }}</vs-th>
          <vs-th>{{ $t("setup.label.PlanStartDate") }}</vs-th>
          <vs-th>{{ $t("setup.label.PlanEndDate") }}</vs-th>
          <vs-th>{{ $t("setup.label.AssignTo") }}</vs-th>
          <vs-th>{{ $t("setup.label.Type") }}</vs-th>
          <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="index" :data="plan" v-for="(plan, index) in data">
            <vs-td :data="plan.planCode">
              {{ plan.planCode }} ({{ plan.externalPlanId }})
            </vs-td>
            <vs-td :data="plan.status" class="statusparent-width">
              {{
                plan.status === 0
                  ? "DRAFT"
                  : plan.status === 1
                  ? "ACTIVE"
                  : plan.status === 2
                  ? "INACTIVE"
                  : plan.status === 4
                  ? "PENDING"
                  : "UNKNOWN"
              }}
            </vs-td>
            <vs-td :data="plan.version">
              {{ plan.version }}
            </vs-td>
            <vs-td :data="plan.isBaseOverride">
              {{ plan.isBaseOverride }}
            </vs-td>
            <vs-td :data="plan.startDate">
              {{ toDate(plan.startDate) }}
            </vs-td>
            <vs-td :data="plan.endDate">
              {{ plan.endDate ? toDate(plan.endDate) : "-" }}
            </vs-td>
            <vs-td :data="plan.assignedTo">
              {{ plan.assignedTo ? plan.assignedTo : "-" }}
            </vs-td>
            <vs-td :data="plan.isPrepaid">
              {{ plan.isPrepaid === "N" ? "Postpaid" : "Prepaid" }}
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <div class="container_img">
                <feather-icon
                  :title="$t('setup.label.View')"
                  icon="EyeIcon"
                  @click.stop="PlanSelected(plan)"
                  svgClasses="w-5 h-5 stroke-current text-primary"
                  class="icon_row"
                />
                <feather-icon
                  icon="EditIcon"
                  :title="$t('setup.label.Edit')"
                  svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                  @click.stop="editData(plan)"
                  class="icon_row"
                />
              </div>
            </vs-td>

            <template v-if="plan.subPlans && plan.subPlans.length > 0" #expand>
              <div class="w-full">
                <vs-table :data="plan.subPlans">
                  <template slot-scope="{ data }">
                    <vs-tr v-for="(subPlan, idx) in data" :key="idx">
                      <vs-td class="plancode-width whitespace-no-wrap">
                        <div class="container_img">
                          <feather-icon
                            icon="PackageIcon"
                            svgClasses="w-5 h-5 mr-3"
                            class=""
                          /><span>{{ subPlan.planCode }}</span>
                        </div></vs-td
                      >
                      <vs-td class="statusexpand-width">
                        {{
                          subPlan.status === 0
                            ? "DRAFT"
                            : subPlan.status === 1
                            ? "ACTIVE"
                            : subPlan.status === 2
                            ? "INACTIVE"
                            : subPlan.status === 4
                            ? "PENDING"
                            : "UNKNOWN"
                        }}
                      </vs-td>
                      <vs-td class="version-width">{{ subPlan.version }}</vs-td>
                      <vs-td class="override-width">{{ subPlan.isBaseOverride }}</vs-td>
                      <vs-td class="startdate-width">{{
                        toDate(subPlan.startDate)
                      }}</vs-td>
                      <vs-td class="enddate-width">{{
                        subPlan.endDate ? toDate(subPlan.endDate) : "-"
                      }}</vs-td>
                      <vs-td>{{
                        plan.assignedTo ? getUserFullName(plan.assignedTo) : "-"
                      }}</vs-td>
                      <vs-td>
                        <div class="container_img">
                          <feather-icon
                            :title="$t('setup.label.View')"
                            icon="EyeIcon"
                            @click="PlanSelected(subPlan)"
                            svgClasses="w-5 h-5 stroke-current text-primary"
                            class="icon_row"
                          />
                          <feather-icon
                            icon="EditIcon"
                            :title="$t('setup.label.Edit')"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="editData(subPlan)"
                            class="icon_row"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </template>
            <template #expand v-else>
              <div>
                <h6>{{ $t("setup.label.No_versions_available") }}</h6>
              </div>
            </template>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { AtomSpinner } from "epic-spinners";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import vSelect from "vue-select";
export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      descriptionItems: [10, 20, 30],
      value: "",
      selectType: "",
      typeOptions: [
        { label: "Prepaid", value: "Y" },
        { label: "Postpaid", value: "N" },
      ],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },
  components: {
    AtomSpinner,
    Multiselect,
    "v-select": vSelect,
  },

  computed: {
    ...mapState({
      planListData: (state) => state.planPrice.planList,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    ...mapGetters({
      userData: "users/getUsersList",
    }),
    planList() {
      const groupedPlans = this.planListData.reduce((acc, plan) => {
        if (!acc[plan.planCode]) {
          acc[plan.planCode] = [];
        }
        acc[plan.planCode].push(plan);
        return acc;
      }, {});

      return Object.values(groupedPlans).map((plans) => {
        const primaryPlan = plans.find((p) => p.primaryDisplay) || plans[0];
        return {
          ...primaryPlan,
          subPlans: plans.filter((p) => p.id !== primaryPlan.id),
        };
      });
    },
    filteredPlanList() {
      if (!this.selectType) return this.planList;
      return this.planList.filter((plan) => plan.isPrepaid === this.selectType);
    },
  },
  methods: {
    async getPlansList() {
      const userData = sessionStorage.getItem("ngb:user");
      const user = JSON.parse(userData);
      const userId = user.userId;
      try {
        await this.$store.dispatch("planPrice/fetchPlanList", userId);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    toDate(data) {
      const d = new Date(data);
      return moment(d).format(this.formattedDate);
    },

    editData(plan) {
      const id = plan.id;
      if (plan.status == 0 && plan.isBaseOverride == false) {
        this.$router.push({
          name: "Edit Plan",
          params: { id: id },
          query: { from: "list", mode: "" },
        });
        return;
      }
      if (plan.status == 2) {
        this.$swal.fire({
          title: "Action Not Allowed",
          text: "You cannot edit an inactive plan.",
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#dc3545",
        });
        return;
      }
      if (plan.isBaseOverride == true || plan.status == 4) {
        this.$router.push({
          name: "Edit Plan",
          params: { id: id },
          query: { from: "list", mode: "isBaseOverride" },
        });
        return;
      }
      if (plan.status == 1 && plan.isBaseOverride == false) {
        this.$swal
          .fire({
            title: "Edit",
            html:
              "<h5 style='display: block; text-align: center;'>If you want to edit the plan, select either 'Override Base' or 'Update Base'.</h5>",
            icon: "info",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "Override Base",
            cancelButtonText: "Update Base",
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#fd7e14",
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$router.push({
                name: "Edit Plan",
                params: { id: id },
                query: { from: "list", mode: "base_override" },
              });
            } else if (result.dismiss === this.$swal.DismissReason.cancel) {
              this.$router.push({
                name: "Edit Plan",
                params: { id: id },
                query: { from: "list", mode: "version_update" },
              });
            }
          });
        return;
      }
    },
    async getUserList() {
      try {
        await this.$store.dispatch("users/setUsersList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    addTicket(id) {
      this.$router.push({ name: "Pricing", params: { id: id } });
    },
    PlanSelected(item) {
      this.$router.push({ name: "View Plan", params: { id: item.id } });
    },
    handleContent(id) {
      this.$router.push({ name: "Plan Content", params: { id: id } });
    },
  },
  async mounted() {
    this.loading = true;
    await this.getPlansList();
    this.loading = false;
  },
};
</script>
<style scoped>
::v-deep .vs__dropdown-toggle {
  height: 37px !important;
}
::v-deep .vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}
::v-deep .vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}
</style>
<style lang="scss">
.vs-search-categeory {
  margin-top: 17px;
}
.plancode-width {
  width: 19%;
}
.statusparent-width {
  width: 11%;
}
.statusexpand-width {
  width: 12%;
}
.version-width {
  width: 8.7%;
}
.override-width {
  width: 11.5%;
}
.startdate-width {
  min-width: 15%;
  width: 15%;
}
.enddate-width {
  min-width: 14.5%;
  width: 14.5%;
}
</style>
